export default {
  environment: 'production',

  breakAd: false,

  googleAnalytics: {
    active: true,
    property: 'UA-92628984-2',
    trackingVersion: '3.1.3'
  },

  shadowTracking: {
      active: true,
  },

  ivw: {
      active: true,
      script: 'https://script.ioam.de/iam.js',
      iam_data: {
          "st": "rtl2", // site/domain
          "cp": null, // code
          "co": "", // kommentar (request path)
          "sv": "ke", // FRABO Steuerung (ke/in)
          "sc":"yes" // Multistage Client & Visit Detection (MCVD)
      }
  },

    agf: {
        // active: true,
        // script: 'https://cdn-gl.imrworldwide.com/novms/js/2/ggcmb510.js',
        apid: 'P86657E4C-08E7-43FC-9298-1C7461DA7E0F',
        config: {
            // sfcode: 'eu-uat', // Environment to use should be 'eu-uat' during testing
            // prod: 'vc',
            // apid: 'T86657E4C-08E7-43FC-9298-1C7461DA7E0F',// Your assigned App ID
            // apn: 'RTL2Player', // Your player name
            // nol_sdkDebug: 'DEBUG' //	During	testing	only,	you	can	enable	full	lo
        }
    },

  jwOptions: {
    autostart: false
  }
}



// WEBPACK FOOTER //
// ./src/settings/production.settings.js